import { Component } from '@angular/core';

@Component({
    selector: 'med-empty-stub-component',
    template: ''
})
export class EmptyStubComponent {}
